import { CSSProperties } from 'react';

// Head/tail split so the discriminating pod-name suffix survives ellipsis.
export const splitName = (name: string, tail = 10): [string, string] => {
  if (name.length <= tail + 6) return [name, ''];
  return [name.slice(0, name.length - tail), name.slice(name.length - tail)];
};

export const NameTail = ({
  name,
  style,
}: {
  name: string;
  style?: CSSProperties;
}) => {
  const [head, tail] = splitName(name);
  return (
    <span
      title={name}
      style={{
        display: 'flex',
        minWidth: 0,
        fontFamily: 'var(--bui-font-monospace)',
        ...style,
      }}
    >
      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          minWidth: 0,
        }}
      >
        {head}
      </span>
      {tail && (
        <span style={{ whiteSpace: 'nowrap', flex: 'none' }}>{tail}</span>
      )}
    </span>
  );
};
